import { SPARK_GRAD } from './AgentLabel';
import { Sparkles, CheckCircle } from '../../../../icons';

export function BrandSafetyAgentCard({
  scans,
  headline,
  description,
  chips,
  onApprove,
  scanNoun = 'videos and comments',
}: {
  scans: number;
  headline: string;
  description: string;
  chips: { label: string; color: string }[];
  onApprove?: () => void;
  /** What the agent scanned, e.g. "videos and comments" (YT) or "posts and comments" (IG). */
  scanNoun?: string;
}) {
  return (
    <div
      style={{
        flex: 1,
        minWidth: 280,
        background: '#fff',
        border: '1px solid #E5E5E5',
        borderRadius: 16,
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #FDFCFE 0%, #F5F1FC 50%, #EAE5F8 100%)',
          border: '1px solid #EADFFB',
          borderRadius: 14,
          padding: 16,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span
          style={{
            width: 52,
            height: 52,
            borderRadius: 100,
            background: SPARK_GRAD,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Sparkles size={24} color="#fff" />
        </span>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#171717' }}>Brand Safety Agent</div>
          <div style={{ fontSize: 14, fontWeight: 400, color: '#737373', marginTop: 2 }}>
            Scans {scans} {scanNoun}.
          </div>
        </div>
        {onApprove && (
          <button
            type="button"
            onClick={onApprove}
            style={{
              flexShrink: 0,
              height: 40,
              padding: '8px 14px',
              borderRadius: 999,
              border: 'none',
              background: '#6C09F7',
              color: '#fff',
              fontSize: 16,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Approve
          </button>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>{headline}</div>
          <p style={{ margin: 0, fontSize: 16, fontWeight: 400, color: '#404040', lineHeight: 1.5 }}>{description}</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {chips.map((ch, i) => (
            <span
              key={i}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: '#fff',
                border: '1px solid #E5E5E5',
                borderRadius: 999,
                padding: '6px 12px',
                fontSize: 16,
                fontWeight: 500,
                color: '#404040',
              }}
            >
              <CheckCircle size={18} color={ch.color} /> {ch.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
